import type { TourConfig } from '../types';

export const adminDashboardPageTour: TourConfig = {
  pageId: 'admin-dashboard',
  pageName: 'Admin Dashboard',
  portalId: 'crm',
  steps: [
    {
      element: '[data-tour="system-status"]',
      title: 'System Status',
      intro:
        'Check configuration health at a glance: commission rules status and last Portal sync timestamp.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="admin-action-cards"]',
      title: 'Admin Actions',
      intro:
        'Quick links to manage users, partner access, commission rules, reports, evidence, and system diagnostics.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
    {
      element: '[data-tour="admin-recent-activity"]',
      title: 'Recent Activity',
      intro:
        'A live feed of partner logins, notes, and visit logs across the system. Click Refresh to fetch the latest.',
      platform: 'both',
      requiredRoles: ['owner', 'admin'],
    },
  ],
};
